import React, { Component } from "react";
import Popover from "@material-ui/core/Popover";
import Button from "@material-ui/core/Button";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import COLORS from "scss/colors.module.scss";
import PickSortColumn from "./PickSortColumn";
import { MdArrowDropDown, MdClose } from "react-icons/md";
import { observer } from "mobx-react";
import styled, { css } from "styled-components";
import { StyledTooltip } from "app/common/utils/StyledTooltip";
import StyledToolbarButton, {
  StyledToolbarTitle,
} from "app/list/ToolBar/StyledToolbarButton";

class Sort extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      isButtonTextOverFlown: false,
    };
    this.arr = [];
    this.handleClick = this.handleClick.bind(this);
    this.sortColumn = this.sortColumn.bind(this);
    this.buttonTextRef = React.createRef();
  }

  handleClick(event) {
    const { anchorEl } = this.state;
    this.setState({
      anchorEl: anchorEl ? null : event.currentTarget,
    });
  }

  sortType = (colId, type) => {
    const columnDef = this.props.store.columnDefs.find(
      (col) => col.colId === colId
    );

    columnDef && (columnDef["sort"] = type);

    this.props.store.setSorting();
  };

  updateButtonTextOverFlowStatus() {
    if (this.buttonTextRef && this.buttonTextRef.current) {
      setTimeout(() => {
        let isTextOverFlown =
          this.buttonTextRef?.current?.scrollWidth >
          this.buttonTextRef?.current?.clientWidth;
        if (
          typeof isTextOverFlown !== "undefined" &&
          isTextOverFlown !== this.state.isButtonTextOverFlown
        ) {
          this.setState({ isButtonTextOverFlown: isTextOverFlown });
        }
      }, 1);
    }
  }

  componentDidUpdate() {
    this.updateButtonTextOverFlowStatus();
  }

  updateColumnDefsSorting = (
    colId,
    order,
    index = this.props.store.sorting.length
  ) => {
    const columnDef = this.props.store.columnDefs.find(
      (col) => col.colId === colId
    );

    if (columnDef) {
      columnDef["sort"] = order;
      columnDef["sortIndex"] = index;
    }

    this.props.store.setSorting();
  };

  replaceColumnDefsSorting = (colIdToReplace, colId, type, index) => {
    const oldColumn = this.props.store.columnDefs.find(
      (col) => col.colId === colIdToReplace
    );
    oldColumn && (oldColumn["sort"] = oldColumn["sortIndex"] = null);

    this.updateColumnDefsSorting(colId, type, index);
  };

  getColumns() {
    let columns = this.props.store.columnDefs
      .filter(
        (col) =>
          col.colId !== "+" && col.colId !== "Actions" && col.colId !== "userEvents" && col.colId !== "commentsId"
      )
      .map((col, index) => {
        return {
          value: col.colId,
          sort: col.sort,
          label: col.headerName,
        };
      });

    if (
      this.props.store?.view?.type == "table" &&
      this.props.store?.view?.list_id &&
      this.props.store?.view?.options?.main_list_id &&
      this.props.store?.view?.list_id !=
        this.props.store?.view?.options?.main_list_id &&
      this.props.store?.isLazyLoadEnabled
    ) {
      columns = columns.filter((col) => col.value !== "Id");
    }
    const sortedColumns = this.props.store.sorting.map((col) => col.colId);
    const sortedTypes = [];
    for (let i = 0; i < this.props.store.sorting.length; i++) {
      let temp = {};
      let colId = this.props.store.sorting[i].colId;
      temp[colId] = this.props.store.sorting[i].sort == "asc" ? "desc" : "asc";
      sortedTypes.push(temp);
    }

    return { columns, sortedColumns, sortedTypes };
  }

  sortColumn(colId, sort, replace, indexOfExistence, type = "asc") {
    if (replace) {
      this.replaceColumnDefsSorting(
        this.props.store.sorting[indexOfExistence]["colId"],
        colId,
        type,
        indexOfExistence
      );
      return;
    }
    this.updateColumnDefsSorting(colId, sort ? type : null);
  }

  render() {
    const { columns, sortedTypes } = this.getColumns();
    const sortedColumns = this.props.store.sorting;
    const sortedColumnIds = sortedColumns.map((col) => col.colId);
    const sortedColumnNames = [];
    for (let i = 0; i < sortedColumns.length; i++) {
      for (let j = 0; j < columns.length; j++) {
        if (sortedColumns[i].colId == columns[j].value) {
          sortedColumnNames.push(columns[j].label);
        }
      }
    }

    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const id = open ? "simple-popper" : null;
    const buttonText =
      sortedColumns.length === 0
        ? "Sort"
        : "Sorted by " +
          sortedColumns.length +
          " field" +
          (sortedColumns.length > 1 ? "s" : "");
    return (
      <>
        <StyledTooltip
          title={buttonText}
          // disableHoverListener={
          //   window.screen.width <= 1401
          //     ? !this.state.isButtonTextOverFlown
          //     : true
          // }
          disableHoverListener={!this.state.isButtonTextOverFlown}
        >
          <StyledToolbarButton
            highlighted={sortedColumns.length != 0}
            className="d-flex"
            screenWidth={window.screen.width}
            onClick={this.handleClick}
            isMaxWidth={true}
          >
            <ImportExportIcon />
            <StyledToolbarTitle
              ref={this.buttonTextRef}
              screenWidth={window.screen.width}
              isMaxWidth={true}
            >
              {buttonText}
            </StyledToolbarTitle>
          </StyledToolbarButton>
        </StyledTooltip>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClick}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <StyledMainDiv>
            {sortedColumns.length > 0 ? (
              sortedColumns.map(({ colId, sort }, index) => {
                return (
                  <div key={index} className="sortByRow">
                    <div className="removeSort">
                      <MdClose
                        className="removeSortIcon"
                        onClick={() => this.sortColumn(colId, false)}
                      />
                      <StyledSortText>
                        {index === 0 ? "Sorted by " : "Then by "}
                      </StyledSortText>
                    </div>
                    <div className="d-flex sortedColumnName">
                      <PickSortColumn
                        columns={columns}
                        sortedColumns={sortedColumnIds}
                        sortColumn={this.sortColumn}
                        sortOrder={sort === "asc" ? "desc" : "asc"}
                        replace={true}
                        indexOfExistence={index}
                        toggleComponent={
                          <div className="d-flex pickColumn">
                            <StyledPickColumnDiv>
                              {sortedColumnNames[index]}
                            </StyledPickColumnDiv>
                            <StyledArrowDropDown className="h-100" />
                          </div>
                        }
                      />

                      <PickSortColumn
                        columns={columns}
                        sortedColumn={colId}
                        sortedType={sort === "asc" ? "desc" : "asc"}
                        sortType={this.sortType}
                        replace={true}
                        indexOfExistence={index}
                        toggleComponent={
                          <div className="d-flex pickColumn">
                            <StyledPickColumnDiv>{sort}</StyledPickColumnDiv>
                            <StyledArrowDropDown className="h-100" />
                          </div>
                        }
                      />
                    </div>
                  </div>
                );
              })
            ) : (
              <StyledDefaultText>
                No sortings applied to this view
              </StyledDefaultText>
            )}
            <StyledOuterDiv>
              <StyledInnerDiv>
                <PickSortColumn
                  columns={columns}
                  sortedColumns={sortedColumnIds}
                  sortColumn={this.sortColumn}
                  toggleComponent={
                    <div className="d-flex pickColumn">
                      <StyledTextDiv>Pick a field to sort by</StyledTextDiv>
                      <StyledArrowDropDown className="h-100" />
                    </div>
                  }
                />
              </StyledInnerDiv>
            </StyledOuterDiv>
          </StyledMainDiv>
        </Popover>
      </>
    );
  }
}

const StyledPickColumnDiv = styled.div`
  color: ${COLORS.TEXT_COLOR},
  font-ize: 12;
  font-weight: 400;
  padding-left: 20;
`;

const StyledArrowDropDown = styled(MdArrowDropDown)`
  font-size: 18px;
  margin-top: 2px;
  margin-left: 5px;
`;

const StyledTextDiv = styled.div`
  color: ${COLORS.TEXT_COLOR};
  font-size: 12px;
  font-style: normal;
  font-weight: 400px;
  padding-left: 10px;
`;

const StyledSortText = styled.div`
  cursor: default;
  color: ${COLORS.TEXT_COLOR};
  font-size: 12px;
  font-weight: 400px;
  opacity: 0.9;
`;

const StyledDefaultText = styled.div`
  color: #bbb;
  padding: 20px;
  font-size: 12px;
`;

const StyledOuterDiv = styled.div`
  display: flex;
`;
const StyledInnerDiv = styled.div`
  flex: 2;
`;

const StyledMainDiv = styled.div`
  min-width: 350px;
`;

export default observer(Sort);
